module.exports = __webpack_public_path__ + "static/media/student-game-comment-next.ff144590.png";